import { GetOrdersParams } from '@/windows/queries/windowApi';

export const keys = {
  create: ['mutation', 'windows', 'order', 'create'],
  getOne: (orderId: string) => ['windows', 'order', orderId],
  getAllPrefix: ['windows', 'orders'],
  getAll: (params: GetOrdersParams) => [
    ...keys.getAllPrefix,
    ...Object.values(params),
  ],
  update: (orderId: string) => [
    'mutation',
    'windows',
    'order',
    'update',
    orderId,
  ],
  submit: ['mutation', 'windows', 'order', 'submit'],
  placeOrder: ['mutation', 'windows', 'order', 'place-order'],
  updateDeliveryAddress: (orderId: string) => [
    'mutation',
    'windows',
    'order',
    'update',
    'delivery-address',
    orderId,
  ],
};
